// Slice to manage all things UI such as button loading, cards loading, modals loading etc.

import { createSlice } from '@reduxjs/toolkit';

interface ButtonState {
    loadingButtons: { [key: string]: boolean }; // this will hold button loading states like { buttonId: true/false }
}

// Assume initial state has a loading object for each button
const initialState: ButtonState = {
    loadingButtons: {} // this will hold button loading states like { buttonId: true/false }
};

// Redux slice or reducer
const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        startLoading: (state, action) => {
            state.loadingButtons[action.payload] = true; // action.payload is button id
        },
        stopLoading: (state, action) => {
            state.loadingButtons[action.payload] = false;
        },
    },
});

export const { startLoading, stopLoading } = uiSlice.actions;
export default uiSlice.reducer;




